import dayjs from 'dayjs'
import certificationKindOptions from '@/helpers/certificationKindOptions'
import { getCertificationSlotTime } from '@/helpers/certification/certificationTermsFormLogic'

function calendarYmd(dateValue) {
  if (dateValue == null || dateValue === '') return null
  if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue
  }
  return dayjs(dateValue).format('YYYY-MM-DD')
}

function kindLabel(kind) {
  const option = certificationKindOptions.find(o => o.value === kind)
  return option ? option.label : (kind || '')
}

function formatCertificationDate(dateValue) {
  const ymd = calendarYmd(dateValue)
  return ymd ? dayjs(ymd).format('DD.MM.YYYY') : ''
}

function formatSlotTimes(slotTimeInputs) {
  return (slotTimeInputs || [])
    .map(slot => {
      const raw = String(getCertificationSlotTime(slot) || '00:00')
      const parts = raw.split(':')
      const hh = (parts[0] || '00').padStart(2, '0')
      const mmRaw = (parts[1] || '00').split(/[.:]/)[0] || '00'
      const mm = String(parseInt(mmRaw, 10) || 0).padStart(2, '0')
      return `${hh}:${mm}`
    })
    .join(', ')
}

/**
 * Podmienia placeholdery w opisie certyfikacji na wartości z formularza.
 * Używane tylko przy budowaniu payloadu API — nie zmienia treści w edytorze.
 */
export default function substituteCertificationDescriptionPlaceholders(description, data) {
  if (!description) {
    return description
  }

  return description
    .replace(/\{rodzaj_certyfikacji\}/g, kindLabel(data.kind))
    .replace(/\{data_certyfikacji\}/g, formatCertificationDate(data.date))
    .replace(/\{godzina_certyfikacji\}/g, formatSlotTimes(data.slotTimeInputs))
    .replace(/\{lokalizacja\}/g, (data.localization || '').trim())
}
